export default __webpack_public_path__ + "static/media/hbs-bpk-poster-2.56451526.jpg";